<template>
  <div class="welcome-page">
    <section class="rectangle-parent">
      <div class="frame-child" />
      <img
        class="mask-group-icon"
        alt=""
        src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/mask-group%402x.png"
      />
      <img
        class="mask-group-icon-mobile"
        alt=""
        src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/mask-group-icon-mobile.png"
      />
      
      <div class="weather-icon">
        <div class="frame-parent">
          <div class="header-frame-wrapper">
            <div class="interest-free-parent">
              <h1 class="interest-free">Interest-Free,</h1>
              <h1 class="splurge-in-three">PAY IN THREE!</h1>
            </div>
          </div>
          <div class="your-spending-limit">
            <div class="frame-group">
              <img
                class="frame-item"
                loading="eager"
                alt=""
                src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/group-4%402x.png"
              />
              <h1 class="debit-card-payments">
                <p class="debit-card">Debit Card</p>
                <p class="payments">Payments</p>
              </h1>
            </div>
            <div class="frame-group">
              <img
                class="frame-item"
                loading="eager"
                alt=""
                src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/group-3%402x.png"
              />
              <!-- <h1 class="instant-approval-for">Pay In 3 Instalments</h1> -->
              <h1 class="debit-card-payments">
                <p class="debit-card">Pay In 3</p>
                <p class="payments">Instalments</p>
              </h1>
            </div>
            <div class="frame-group">
              <img
                class="frame-item"
                loading="eager"
                alt=""
                src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/group-5%402x.png"
              />
              <h1 class="instant-approval-for">
                Instant access to a spending limit
              </h1>
              <h1 class="instant-approval-for-mobile">
                Instant spending limit
              </h1>
            </div>
          </div>
        </div>
      </div>
      <img
        class="mainlogo-hd-h-2101-1-icon"
        loading="eager"
        alt=""
        src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/mainlogohd-h-2101-1%402x.png"
      />
    </section>
    
    <section class="dynamic-nature">
  <div class="blink-logo-web">
    <div class="shopping-bag">
      <h1 class="getting-started-with">Getting started with Koko</h1>
      <h1 class="how-to-register-your">
        How to register your card on Koko
      </h1>
    </div>
  </div>
  <div class="up-to-off-frame">
    <div class="up-to-off-frame-inner">
      <div class="frame-parent1">
        <div :class="['step-01-parent', currentStep === 1 ? '' : 'inactive']" @click="showStep(1)">
          <div class="step-01">Step 01</div>
          <h1 class="open-the-koko">Open the Koko app</h1>
        </div>
        <div :class="['step-02-parent', currentStep === 2 ? '' : 'inactive']" @click="showStep(2)">
          <div class="step-02">Step 02</div>
          <h1 class="tap-on-my">Tap on "My Koko."</h1>
        </div>
        <div :class="['step-03-parent', currentStep === 3 ? '' : 'inactive']" @click="showStep(3)">
          <div class="step-03">Step 03</div>
          <h1 class="navigate-to-payment">Navigate to "Payment Method."</h1>
        </div>
        <div :class="['step-04-parent', currentStep === 4 ? '' : 'inactive']" @click="showStep(4)">
          <div class="step-04">Step 04</div>
          <h1 class="click-on-add">Click on "Add a New Payment Method."</h1>
        </div>
        <div :class="['step-05-parent', currentStep === 5 ? '' : 'inactive']" @click="showStep(5)">
          <div class="step-05">Step 05</div>
          <h1 class="verify-your-card">Register your card.</h1>
        </div>
      </div>
    </div>
    <div class="up-to-off-frame-child">
      <div class="rectangle-group-section-2">
        <div class="rectangle-section-2"></div>
        <div :class="['step-step', `step-step-${currentStep}`]"></div>
      </div>
    </div>
    <div class="rectangle-container-reg">
      <div class="frame-child1"></div>
      <img
          v-for="(url1, index) in regImageUrls"
          :key="index"
          
          class="mask-group-icon1"
          loading="eager"
          alt=""
          :src="url1"
          v-show="currentStep === index + 1"
        />
    </div>
  </div>
</section>
<!-- Top deals section -->
<section class="top-deals-label-parent">
  <div class="top-deals-label">
    <h1 class="top-deals">Top Deals</h1>
  </div>
  <div class="deals-container">
    <div class="deals-frame-parent1">
      <div class="mx-2">
        <div class="row">
          <div class="fashion_body">
            <section>
              <div class="cards-wrapper3" style="margin-left: -10px;">
                <div
                  class="card5"
                  style="padding-right: 10px; position: relative"
                  v-for="items in TopDealStores"
                  :key="items.id"
                >
                  <router-link
                    :to="'/m/merchant/' + items.Merchant_Id"
                    style="text-decoration: none; font-weight: bold"
                  >
                    <div v-if="items.Merchant_Discount" class="badge">{{ items.Merchant_Discount }}</div>
                    <div class="badge3" v-if="items.merchant_types.length > 0">
                      <span>
                        <img
                          src="@/assets/images/shopping-bag.png"
                          alt="“merchant-type-logo”"
                          height="6"
                          style="margin-right: 2px; margin-top: -2px"
                        />
                      </span>
                      <span
                        class="bg animated fadeInDown"
                        style="color: #000000"
                        v-for="type in items.merchant_types"
                        :key="type.id"
                        >{{ type.Type }}
                        <span
                          v-if="type != items.merchant_types.slice(-1)[0]"
                          style="padding-left: 2px"
                          >&</span
                        >
                      </span>
                    </div>
                    <img
                      :src="items.Merchant_Thumbnail.url"
                      class="card-image"
                      style="
                        text-align: center;
                        border-radius: 16px;
                      "
                    />
                  </router-link>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


    <section class="welcome-page-inner">
      <div class="rectangle-parent1">
        <div class="frame-child2" />
        <h1 class="how-to-make">How to make payments with Koko</h1>
        <div class="frame-parent2">
          <div class="instore-payments-wrapper">
            <h1 class="instore-payments">Instore Payments</h1>
          </div>
          <div class="section-4-icon">
            <!-- <div class="instore-online">
              <img
                class="mask-group-icon2"
                alt=""
                src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/mask-group-2%402x.png"
              />
              <img
                class="highlight-07-icon"
                loading="eager"
                alt=""
                src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/highlight-07%402x.png"
              />
            </div> -->
            <!-- <div class="instore-online1">
              <div class="instore-online-child" />
              <img
                class="mask-group-icon4"
                loading="eager"
                alt=""
                src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/croped-group-2-1.png"
              />
            </div>
            <div class="section-4-icon-inner">
              
                <div class="rectangle-parent2">
                <div class="frame-child3" />
                <img
                  class="iphone-12-16-pro-1"
                  loading="eager"
                  alt=""
                  src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/croped-group-2-2.png"
                />
              </div>
            </div>
            <div class="instore-online1">
              <div class="instore-online-child" />
              <img
                class="mask-group-icon4"
                loading="eager"
                alt=""
                src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/croped-group-2-3.png"
              />
            </div> -->
            <div class="caption-head">
            <div class="">
                <div class="frame-child5" />
                <img
                  class="iphone-12-15-pro-1"
                  loading="eager"
                  alt=""
                  src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/payment-1.png"
                />
                
              </div>
             <div ><h1 class="caption">Click</h1></div>
            </div>  
            <div class="caption-head">
            <div class="">
                <div class="frame-child4" />
                <img
                  class="iphone-12-15-pro-1"
                  loading="eager"
                  alt=""
                  src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/payment-2.png"
                />
              </div>
              <div ><h1 class="caption">Scan</h1></div>
            </div>

            <div class="caption-head">
              <div class="">
                <div class="frame-child5" />
                <img
                  class="iphone-12-15-pro-1"
                  loading="eager"
                  alt=""
                  src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/payment-3.png"
                />
              </div>
              <div ><h1 class="caption">Pay</h1></div>

            </div>
          </div>
          <!-- <div class="wealth-box">
            <div class="click-parent">
              <h1 class="click">Click</h1>
              <div class="scan-wrapper">
                <h1 class="scan">Scan</h1>
              </div>
              <h1 class="pay">Pay</h1>
            </div>
          </div> -->
        </div>
        <div class="rectangle">
          <div class="dynamic-nature1">
            <h1 class="online-payments">Online Payments</h1>
          </div>
          <div class="mask-group">
            <div class="frame-parent3">
              <div class="caption-head">
              <div class="">
              <!-- <div class="rectangle-parent3"> -->

                <div class="frame-child4" />
                <img
                  class="iphone-12-15-pro-5"
                  loading="eager"
                  alt=""
                  src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/payment-4.png"
                />
              </div>
              <div ><h1 class="caption2">Choose Koko at checkout</h1></div>
            </div>
              <div class="caption-head">
              <div class="">
                <!-- <div class="rectangle-parent4"> -->
                <div class="frame-child5" />
                <img
                  class="iphone-12-15-pro-1"
                  loading="eager"
                  alt=""
                  src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/payment-6.png"
                />
              </div>
              <div ><h1 class="caption2">Log in with your details</h1></div>
            </div>
              <div class="caption-head">
              <!-- <div class="rectangle-parent5"> -->
              <div class="">

                <div class="frame-child6" />
                <img
                  class="iphone-12-15-pro-1"
                  loading="eager"
                  alt=""
                  src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/payment-5.png"
                />
              </div>
              <div ><h1 class="caption3">Make your first installment payment</h1></div>
            </div>
            </div>
            
          </div>
        </div>
       
      </div>
    </section>
    <section class="frame-with-masks">
      <h1 class="ready-to-boost">
        Ready to Boost Your Spending Limit with Koko?
      </h1>
      <div class="three-step-frame">
        <div class="dynamic-nature2">
          <div class="user-assessment">

            <div class="document-rectangle-group-section-2">
          <!-- Horizontal progress bar -->
          <div class="document-rectangle-section-2"></div>
          <!-- Movable thumb -->
          <div :class="['document-step-step', limitBoost0 ? 'step-1' : 'step-2']"></div>
        </div>

            <div class="two-frames">
              <div class="frame-with-rectangle">
                <h1 :class="[limitBoost0? 'dynamic-nature4':'step-021']" @click="showStep0">Step 01</h1>
                <div v-if=limitBoost0 class="rectangle-shape1" />
              </div>
              <div class="frame-with-rectangle1">
              <div :class="[limitBoost1? 'dynamic-nature4':'step-011']" @click="showStep1">Step 02</div>
              <div v-if=limitBoost1 class="rectangle-shape1" />
            </div>
              <!-- <div class="frame-with-rectangle1">
              <div :class="[limitBoost2? 'dynamic-nature4':'step-011']" @click="showStep2">Step 02</div>
              <div v-if=limitBoost2 class="rectangle-shape1" />
            </div> -->
            </div>
            <div v-if="limitBoost1">
              <h1 class="pro-tip">Dynamic Nature</h1>
            <h1 class="your-spending-limit1">
              Your spending limit is unique to you & is auto assigned day-in and day-out by our system. Our decision-engine regularly updates your spending limit based on your usage, uploads, and seasonal trends  
            </h1>
          </div>
            <div v-if="limitBoost0">
              <h1 class="scan-and-upload">Scan and Upload your documents</h1>
              <h1 class="salary-slip-nic-container1">
              <ul class="documents">
                <li class="salary-slip1">Salary slip</li>
                <li class="nic-front1">NIC front</li>
                <li class="nic-back1">NIC back</li>
                <li>Utility bill</li>
              </ul>
            </h1>
            </div>
            <!-- <div v-if="limitBoost2">
              <h1 class="pro-tip">Dynamic Nature</h1>
              <h1 class="if-the-document">
                Your spending limit is unique to you & is auto assigned day-in and
              day-out by our system. Our decision-engine regularly updates your
              speeding limit based on your usage, uploads, campaigns, and
              current market conditions.
              </h1>
            </div> -->
          
          </div>
        </div>
        <div class="parent-mask-group">
          <div class="parent-mask-group-child" />
          <img
            class="mask-group-icon5"
            loading="eager"
            alt=""
            src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/mask-group-5%402x.png"
          />
        </div>
      </div>
    </section>
    <div class="three-frames">
      <div class="why-love-koko">
        <h1 class="we-do-it">We do it all for you</h1>
        <h1 class="why-people-love">Why people love Koko</h1>
      </div>
    </div>

    <section class="parent-mask-group-stack">
  <div class="three-frames-group" ref="carousel">
    <div class="three-frames-group-child"></div>
    <img
      v-for="(url, index) in imageUrls"
      :key="index"
      class="mask-group-icon6"
      loading="eager"
      alt=""
      draggable="false"
      :src="url"
      
    />
  </div>
</section>
    <section class="parent-frame">
      <div class="child-frame">
        <h1 class="only-the-best">Only the best for you</h1>
      </div>
      <div class="rectangle1">

        <div class="deals-section">
  <div class="deals-row">
    <div class="deals-container">
      <section>
        <!-- First row of product cards -->
        <div class="deals-cards-row" style="margin-left: -10px;">
          <div
            class="deal-card"
            style="padding-right: 10px; position: relative"
            v-for="(items) in BestForYouStores.slice(0, 6)"
            :key="items.id"
          >
            <router-link
              :to="'/m/merchant/' + items.Merchant_Id"
              style="text-decoration: none; font-weight: bold"
            >
              <div v-if="items.Merchant_Discount" class="discount-badge">{{ items.Merchant_Discount}}</div>
              <div class="merchant-type-badge" v-if="items.merchant_types.length > 0">
                <span>
                  <img
                    src="@/assets/images/shopping-bag.png"
                    alt="merchant-type-logo"
                    height="6"
                    style="margin-right: 2px; margin-top: -2px"
                  />
                </span>
                <span
                  class="bg animated fadeInDown"
                  style="color: #000000"
                  v-for="type in items.merchant_types"
                  :key="type.id"
                  >{{ type.Type }}
                  <span
                    v-if="type != items.merchant_types.slice(-1)[0]"
                    style="padding-left: 2px"
                    >&</span
                  >
                </span>
              </div>
              <img
                :src="items.Merchant_Thumbnail.url"
                class="deal-card-image"
                style="text-align: center; border-radius: 16px;"
              />
            </router-link>
          </div>
        </div>

        <!-- Second row of product cards -->
        <div class="deals-cards-row" style="margin-left: -10px;">
          <div
            class="deal-card"
            style="padding-right: 10px; position: relative"
            v-for="(items) in BestForYouStores.slice(6, 12)"
            :key="items.id"
          >
            <router-link
              :to="'/m/merchant/' + items.Merchant_Id"
              style="text-decoration: none; font-weight: bold"
            >
              <div v-if="items.Merchant_Discount" class="discount-badge">{{ items.Merchant_Discount }}</div>
              <div class="merchant-type-badge" v-if="items.merchant_types.length > 0">
                <span>
                  <img
                    src="@/assets/images/shopping-bag.png"
                    alt="merchant-type-logo"
                    height="6"
                    style="margin-right: 2px; margin-top: -2px"
                  />
                </span>
                <span
                  class="bg animated fadeInDown"
                  style="color: #000000"
                  v-for="type in items.merchant_types"
                  :key="type.id"
                  >{{ type.Type }}
                  <span
                    v-if="type != items.merchant_types.slice(-1)[0]"
                    style="padding-left: 2px"
                    >&</span
                  >
                </span>
              </div>
              <img
                :src="items.Merchant_Thumbnail.url"
                class="deal-card-image"
                style="text-align: center; border-radius: 16px;"
              />
            </router-link>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

      </div>
    </section>
  </div>
</template>
  <script>
import { defineComponent } from "vue";
import Strapi from "../services/strapi-services.js";
import "@fontsource/open-sauce-sans/900.css";
import "@fontsource/open-sauce-sans/400.css";
import "@fontsource/open-sauce-one/900.css";
import "@fontsource/open-sauce-one/700.css";
import "@fontsource/open-sauce-one/400.css";


const strapi = new Strapi();

export default defineComponent({
  name: "WelcomePage",
  data(){
    return{
      limitBoost0:true,
      limitBoost1:false,
      limitBoost2:false,

      registerStep1:true,
      registerStep2:false,
      registerStep3:false,
      registerStep4:false,
      registerStep5:false,

      isDragStart:false,
      prevPageX:0,
      preScrollLeft:0,
      imageUrls:[     
        // "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/mask-group-6%402x.png",
        // "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/mask-group-6%402x.png",
        // "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/mask-group-6%402x.png",

        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Frame%2036.png",
        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Frame%2037.png",
        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Frame%2038.png",
        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Frame%2039.png",
        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Frame%2040.png",
        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Frame%2041.png",
        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Frame%2042.png",

      
      ],
      currentStep: 1,
      regImageUrls: [
        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Mask%20group1.png",
        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Mask%20group2.png",
        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Mask%20group3.png",
        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Mask%20group4.png",
        "https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/Mask%20group5.png",



        
      ],
      intervalId: null,
      TopDealStores: [],
      BestForYouStores:[],
    }
  },
  // computed: {
  //   filteredImageUrls() {
  //     return this.reImageUrls.filter((url, index) => this.currentStep === index + 1);
  //   },
  // },
    methods:{
      getTopDealStores() {
      strapi
        .getInspirationalListThumbnails()
        .then((res) => {
          this.TopDealStores = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getBestForYouStores() {
      strapi
        .getInspirationalAllProducts()
        .then((res) => {
          this.BestForYouStores = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    
      showStep0(){
        this.limitBoost0=true
        this.limitBoost2=false        
        this.limitBoost1=false
      },
      showStep1(){
        this.limitBoost1=true 
        this.limitBoost2=false
        this.limitBoost0=false
      },
      showStep2(){
        this.limitBoost2=true
        this.limitBoost0=false
        this.limitBoost1=false
      },

      showRegStep1(){
        this.registerStep1=true
        this.registerStep2=false
        this.registerStep3=false
        this.registerStep4=false
        this.registerStep5=false

      },
      showRegStep2(){
        this.registerStep2=true
        this.registerStep1=false
        this.registerStep3=false
        this.registerStep4=false
        this.registerStep5=false
      },
      showRegStep3(){
        this.registerStep3=true
        this.registerStep2=false
        this.registerStep1=false
        this.registerStep4=false
        this.registerStep5=false
      },
      showRegStep4(){
        this.registerStep4=true
        this.registerStep2=false
        this.registerStep3=false
        this.registerStep1=false
        this.registerStep5=false
      },
      showRegStep5(){
        this.registerStep5=true
        this.registerStep2=false
        this.registerStep3=false
        this.registerStep1=false
        this.registerStep4=false
      },
      dragStart(e) {
        this.isDragStart = true;
        this.prevPageX = e.pageX;
        this.preScrollLeft = this.$refs.carousel.scrollLeft;
      },

      dragging(e) {
        if (!this.isDragStart) return;
        e.preventDefault();
        let positionDiff = e.pageX - this.prevPageX;
        this.$refs.carousel.scrollLeft = this.preScrollLeft - positionDiff;
      },

      dragStop() {
        this.isDragStart = false;
      },
      showStep(step) {
      this.currentStep = step;
      this.resetInterval();
    },
    nextStep() {
      this.currentStep = this.currentStep < 5 ? this.currentStep + 1 : 1;
    },
    resetInterval() {
      clearInterval(this.intervalId);
      this.intervalId = setInterval(this.nextStep, 3000);
    },
    },
    mounted() {
      const carousel = this.$refs.carousel;
      carousel.addEventListener("mousedown", this.dragStart);
      carousel.addEventListener("mousemove", this.dragging);
      carousel.addEventListener("mouseup", this.dragStop);

      this.intervalId = setInterval(this.nextStep, 3000);
      
      this.getTopDealStores();
      this.getBestForYouStores();
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
});

</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@400;700;800&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400&display=swap");


body {
  margin: 0;
  line-height: normal;
}
.frame-child {
  height: 594px;
  width: 1280px;
  position: relative;
  border-radius: 0px 0px 233px 0px;
  background-color: #b5def0;
  display: none;
  max-width: 100%;
  z-index: 0;
}
.mask-group-icon {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  height: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
  object-fit: contain;
  z-index: 1;
}
.interest-free {
  margin: 0;
  width: 425px;
  position: relative;
  font-size: inherit;
  line-height: 151.11%;
  font-weight: 900;
  font-family: 'Open Sauce One';
  font-size: 58px;
  display: inline-block;
  max-width: 100%;
  z-index: 2;
  
}
.splurge-in-three {
  margin: 0;
  align-self: flex-start;
  position: relative;
  font-size: 78px;
  line-height: 151.11%;
  font-weight: 900;
  font-family: 'Open Sauce One';
  z-index: 2;
  margin-top: -22px;
}
.interest-free-parent {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 100%;
  color: #fff;
}
.header-frame-wrapper {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 0px 0px 12px;
  box-sizing: border-box;
  max-width: 100%;
}
.frame-item {
  width: 147px;
  height: 147px;
  position: relative;
  object-fit: cover;
  z-index: 2;
}
.debit-card {
  margin: 0;
}
.payments {
  margin: 0;
}
.debit-card-payments {
  margin: 0;
  align-self: stretch;
  position: relative;
  font-size: inherit;
  line-height: 134%;
  font-weight: 400;
  font-family: "Open Sauce One";
  z-index: 2;
}

.frame-item {
  width: 147px;
  height: 147px;
  position: relative;
  object-fit: cover;
  z-index: 2;
}
.pay-in-3 {
  margin: 0;
  align-self: stretch;
  position: relative;
  font-size: inherit;
  line-height: 134%;
  font-weight: 400;
  font-family: inherit;
  z-index: 2;
}
.frame-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  
}
.group-icon {
  width: 147px;
  height: 147px;
  position: relative;
  object-fit: cover;
  z-index: 2;
}
.instant-approval-for {
  margin: 0;
  align-self: stretch;
  position: relative;
  font-size: inherit;
  line-height: 134%;
  font-weight: 400;
  font-family: "Open Sauce One";
  z-index: 2;
  
}
.instant-approval-for-mobile {
  margin: 0;
  align-self: auto;
  position: relative;
  font-size: inherit;
  line-height: 134%;
  font-weight: 400;
  font-family: inherit;
  z-index: 2;
  display:none;
  width: 100px;
  font-family: "Open Sauce One";
}
.frame-div {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 11px;
  min-width: 129px;
}
.your-spending-limit {
  width: 564px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;
  max-width: 100%;
  text-align: center;
  font-size: 15px;
  color: #021fa3;
}
.frame-parent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 41px;
  max-width: 100%;
}
.weather-icon {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 78px 0px 0px;
  box-sizing: border-box;
  min-width: 535px;
  max-width: 100%;
}
.mainlogo-hd-h-2101-1-icon {
  height: 104px;
  width: 206px;
  position: relative;
    object-fit: cover;
    z-index: 2;
}
.rectangle-parent {
  align-self: stretch;
  border-radius: 0px 0px 233px 0px;
  background-color: #D0C0DD;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 6px 27px 83px 53px;
  box-sizing: border-box;
  position: relative;
  gap: 171px;
  max-width: 100%;
  text-align: left;
  font-size: 58px;
  color: #fff;
  font-family: "Open Sauce One";
  overflow: hidden;
}
.getting-started-with {
  margin: 0;
  position: relative;
  font-size: inherit;
  font-weight: 400;
  font-family: inherit;
  display: inline-block;
  max-width: 100%;
}
.how-to-register-your {
  margin: 0;
  align-self: stretch;
  height: 106px;
  position: relative;
  font-size: 45px;
  font-weight: 700;
  font-family: inherit;
  display: inline-block;
}
.shopping-bag {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  max-width: 100%;
}
.blink-logo-web {
  width: 572px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 6px 0px 0px;
  box-sizing: border-box;
  max-width: 100%;
}
.inactive{
  opacity:0.3;
}
.step-01 {
  flex: 1;
  position: relative;
  line-height: 141%;
  font-weight: 900;
}
.open-the-koko {
  margin: 0;
  align-self: stretch;
  position: relative;
  font-size: 22px;
  line-height: 141%;
  font-weight: 400;
  font-family: Raleway;
  color: #000;
}
.step-01-parent {
  width: 284px;
  height: 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 11px;
  cursor:pointer;
}
.step-02 {
  flex: 1;
  position: relative;
  line-height: 141%;
  font-weight: 900;
}
.tap-on-my {
  margin: 0;
  align-self: stretch;
  position: relative;
  font-size: 22px;
  line-height: 141%;
  font-weight: 400;
  font-family: Raleway;
  color: #000;
}
.step-02-parent {
  width: 284px;
  height: 70px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 11px;
  cursor:pointer;
}
.step-03 {
  height: 28px;
  position: relative;
  line-height: 141%;
  font-weight: 900;
  display: inline-block;
  flex-shrink: 0;
}
.navigate-to-payment {
  margin: 0;
  align-self: stretch;
  position: relative;
  font-size: 22px;
  line-height: 141%;
  font-weight: 400;
  font-family: Raleway;
  color: #000;
}
.step-03-parent {
  width: 357px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 11px;
  max-width: 100%;
  cursor:pointer;
}
.step-04 {
  height: 28px;
  position: relative;
  line-height: 141%;
  font-weight: 900;
  display: inline-block;
  flex-shrink: 0;
}
.click-on-add {
  margin: 0;
  align-self: stretch;
  position: relative;
  font-size: 22px;
  line-height: 141%;
  font-weight: 400;
  font-family: Raleway;
  color: #000;
}
.step-04-parent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 11px;
  cursor:pointer;
}
.step-05 {
  height: 28px;
  position: relative;
  line-height: 141%;
  font-weight: 900;
  display: inline-block;
  flex-shrink: 0;
}
.verify-your-card {
  margin: 0;
  align-self: stretch;
  position: relative;
  font-size: 22px;
  line-height: 141%;
  font-weight: 400;
  font-family: Raleway;
  color: #000;
}
.step-05-parent {
  width: 357px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 11px;
  max-width: 100%;
  cursor:pointer;
}
.frame-parent1 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 26px;
  max-width: 100%;
}
.up-to-off-frame-inner {
  width: 391px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 8px 0px 0px;
  box-sizing: border-box;
  max-width: 100%;
}
.rectangle-section-2 {
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 47px;
  background-color: rgba(217, 217, 217, 0.96);
  width: 100%;
  height: 100%;
  display: none;
}
.step-step {
  position: absolute;
  left: 0px;
  border-radius: 47px;
  background-color: #0217a3;
  width: 4px;
  height: 74px;
  z-index: 1;
}
.step-step-1{
  top:0;
}
.step-step-2{
  top:76.5px;
}
.step-step-3{
  top:153px;
}
.step-step-4{
  top:229.5px;
}
.step-step-5{
  top:306px;
}
.rectangle-group-section-2 {
  width: 4px;
  height: 380px;
  position: relative;
  border-radius: 47px;
  background-color: rgba(217, 217, 217, 0.96);
}
.up-to-off-frame-child {
  width: 53px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 20px 0px;
  box-sizing: border-box;
}
.frame-child1 {
  align-self: stretch;
  width: 496px;
  position: relative;
  border-radius: 36px;
  background-color: rgba(217, 217, 217, 0.41);
  display: none;
  max-width: 100%;
}
.mask-group-icon1 {
  height: 530px;
  flex: 1;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  object-fit: contain;
  z-index: 1;
}

.rectangle-container-reg{
  /*flex: 1;*/
  border-radius: 36px;
  background-color: rgba(217, 217, 217, 0.41);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 322px;
  max-width: 100%;
}
/* Mobile view adjustments */
@media (max-width: 750px) {
  .up-to-off-frame {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  .rectangle-container-reg {
    order: -1; 
  }

  

  .up-to-off-frame-child {
    order: 0; 
    margin-bottom: 16px;
  }

  .up-to-off-frame-inner {
    order: 2; 
  }
}
.up-to-off-frame {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 36px;
  max-width: 100%;
  text-align: left;
  font-size: 26px;
  color: #0217a3;
  font-family: "Open Sauce Sans";
}
.dynamic-nature {
  width: 1052px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  box-sizing: border-box;
  gap: 49px;
  min-height: 768px;
  max-width: 100%;
  text-align: center;
  font-size: 30px;
  color: #000;
  font-family: Raleway;
}
.frame-child2 {
  width: 1280px;
  position: relative;
  border-radius: 233px 0px 0px 0px;
  background-color: #b5def0;
  height: 1420px;
  display: none;
  max-width: 100%;
  z-index: 0;
}
.how-to-make {
  margin: 0;
  position: relative;
  font-size: 45px;
  font-weight: 800;
  font-family: inherit;
  color: #000;
  text-align: left;
  display: inline-block;
  max-width: 100%;
  z-index: 1;
}
.instore-payments {
  margin: 0;
  position: relative;
  font-size: inherit;
  font-weight: 550;
  font-family: inherit;
  z-index: 1;
  color: #000;

text-align: center;
font-family: Raleway;
font-size: 30px;
font-style: normal;
line-height: normal;
  
}
.instore-payments-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 15px 0px 0px;
}
.mask-group-icon2 {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
  object-fit: contain;
  z-index: 1;
}
.highlight-07-icon {
  position: absolute;
  bottom: 54.2px;
  left: 110.8px;
  width: 63.3px;
  height: 55.7px;
  object-fit: contain;
  z-index: 2;
}
.instore-online {
  height: 389px;
  position: relative;
  max-width: 100%;
}
.frame-child3 {
  position: absolute;
  top: 0px;
  left: 0px;
  border-radius: 30px;
  background-color: #fff;
  width: 100%;
  height: 100%;
  display: none;
  z-index: 1;
}
.mask-group-icon3 {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 2;
}
.iphone-12-16-pro-1 {
  position: absolute;
  top: 38px;
  left: 3px;
  width: 292px;
  height: 351px;
  object-fit: cover;
  z-index: 3;
}
.rectangle-parent2 {
  align-self: stretch;
  height: 389px;
  position: relative;
  border-radius: 30px;
  background-color: #fff;
  z-index: 1;
}
.section-4-icon-inner {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 0px 5px;
  box-sizing: border-box;
  max-width: 100%;
}
.instore-online-child {
  align-self: stretch;
  width: 350px;
  position: relative;
  border-radius: 30px;
  background-color: #fff;
  display: none;
  max-width: 100%;
}
.mask-group-icon4 {
  height: 389px;
  flex: 1;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  object-fit: contain;
  z-index: 2;
  bottom: 28px;
}
.instore-online1 {
  border-radius: 30px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  z-index: 1;
}
.section-4-icon {
  align-self: stretch;
  display: grid;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 200px;
  /*overflow: auto;*/
  max-width: 100%;
  grid-template-columns: repeat(3, minmax(262px, 1fr));
}
.section-4-icon::-webkit-scrollbar {
  /*display: none; */
}
.frame-parent3::-webkit-scrollbar {
  /*display: none; */
}
.click {
  margin: 0;
  flex: 1;
  position: relative;
  font-size: inherit;
  line-height: 122.22%;
  font-weight: 400;
  font-family: inherit;
  display: inline-block;
  min-width: 31px;
  z-index: 1;
}
.scan {
  margin: 0;
  position: relative;
  font-size: inherit;
  line-height: 122.22%;
  font-weight: 400;
  font-family: inherit;
  z-index: 1;
}
.caption{
  margin:31px auto 0 auto;
 
  width: 60px;
height: 26px;
flex-shrink: 0;
color: #000000;

font-family: Raleway;
font-size: 22px;
font-style: normal;
font-weight: 400;
line-height: 122.222%; /* 26.889px */
}
.caption2{
  margin:31px auto 0 auto;
 
  width: 185px;
height: 56px;
flex-shrink: 0;
color: #000000;

font-family: Inter;
font-size: 22px;
font-style: normal;
font-weight: 400;
line-height: 122.222%; /* 26.889px */
}
.caption3{
  margin:31px auto 0 auto;
 
  width: 248px;
height: 56px;
flex-shrink: 0;
color: #000000;

font-family: Inter;
font-size: 22px;
font-style: normal;
font-weight: 400;
line-height: 122.222%; /* 26.889px */
}
.caption-head{
  align-items: center;
  display: grid;
  margin-bottom:5%;
}
.scan-wrapper {
  flex: 0.8276;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 10px 0px 0px;
  box-sizing: border-box;
  min-width: 38px;
}
.pay {
  margin: 0;
  position: relative;
  font-size: inherit;
  line-height: 122.22%;
  font-weight: 400;
  font-family: inherit;
  z-index: 1;
}
.click-parent {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  max-width: 100%;
}
.wealth-box {
  width: 882px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 26px 0px 0px;
  box-sizing: border-box;
  max-width: 100%;
  font-size: 22px;
}
.frame-parent2 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 30px;
  max-width: 100%;
}
.online-payments {
  margin: 0;
  position: relative;
  font-size: 30px;
  font-weight: 550;
  font-family: inherit;
  z-index: 1;
  color:#000;
}
.dynamic-nature1 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 10px 0px 0px;
}
.frame-child4 {
  align-self: stretch;
  width: 350px;
  position: relative;
  border-radius: 30px;
  background-color: #fff;
  display: none;
  max-width: 100%;
}
.iphone-12-12-pro-5 {
  height: 349px;
  width: 298px;
  position: relative;
  object-fit: cover;
  z-index: 2;
}
.rectangle-parent3 {
  height: 389px;
  border-radius: 30px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  max-width: 100%;
  z-index: 1;
}
.frame-child5 {
  height: 389px;
  width: 350px;
  position: relative;
  border-radius: 30px;
  background-color: #fff;
  display: none;
  max-width: 100%;
}
.iphone-12-11-pro-1 {
  height: 356px;
  width: 290px;
  position: relative;
  object-fit: cover;
  z-index: 2;
}
.rectangle-parent4 {
  border-radius: 30px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  padding: 0px 0px 33px;
  box-sizing: border-box;
  max-width: 100%;
  z-index: 1;
}
.frame-child6 {
  height: 389px;
  width: 350px;
  position: relative;
  border-radius: 30px;
  background-color: #fff;
  display: none;
  max-width: 100%;
}
.iphone-12-15-pro-1 {
  height: 389px;
  width: 350px;
  border-radius: 30px;
  position: relative;
  object-fit: cover;
  z-index: 2;
}
.rectangle-parent5 {
  border-radius: 30px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  padding: 27px 0px 0px;
  box-sizing: border-box;
  max-width: 100%;
  z-index: 1;
}
.frame-parent3 {
  align-self: stretch;
  display: grid;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 200px;
  /*overflow: auto;*/
  max-width: 100%;
  grid-template-columns: repeat(3, minmax(262px, 1fr));
}
.choose-koko-at {
  margin: 0;
  align-self: stretch;
  height: 56px;
  position: relative;
  font-size: inherit;
  font-weight: 400;
  font-family: inherit;
  display: inline-block;
  flex-shrink: 0;
  z-index: 1;
}
.choose-koko-at-checkout-wrapper {
  width: 215px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 30px 0px 0px;
  box-sizing: border-box;
}
.log-in-with {
  margin: 0;
  height: 56px;
  width: 186px;
  position: relative;
  font-size: inherit;
  font-weight: 400;
  font-family: inherit;
  display: inline-block;
  flex-shrink: 0;
  z-index: 1;
}
.make-your-first {
  margin: 0;
}
.installment-payment {
  margin: 0;
}
.make-your-first-container {
  margin: 0;
  align-self: stretch;
  position: relative;
  font-size: inherit;
  font-weight: 400;
  font-family: inherit;
  z-index: 1;
}
.make-your-first-installment-pa-wrapper {
  width: 248px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 0px 6px;
  box-sizing: border-box;
}
.frame-parent4 {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  max-width: 100%;
}
.mask-group-inner {
  width: 1070px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 0px 0px 31px;
  box-sizing: border-box;
  max-width: 100%;
}
.mask-group {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 25px;
  max-width: 100%;
  font-size: 22px;
  font-family: Inter;
}
.rectangle {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 31px;
  max-width: 100%;
}
.koko-angel-1-1 {
  width: 388px;
  height: 388px;
  position: absolute;
  margin: 0 !important;
  top: -154px;
  left: 3px;
  object-fit: cover;
  z-index: 2;
}
.rectangle-parent1 {
  flex: 1;
  border-radius: 233px 0px 0px 0px;
  background-color: rgba(249, 246, 241, 0.80);;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 69px 54px 87px;
  box-sizing: border-box;
  position: relative;
  gap: 66px;
  max-width: 100%;
}
.welcome-page-inner {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 0px 56px;
  box-sizing: border-box;
  max-width: 100%;
  text-align: center;
  font-size: 38px;
  color: #0217a3;
  font-family: Raleway;
}
.ready-to-boost {
  margin: 0;
  width: 694px;
  height: 106px;
  position: relative;
  font-size: inherit;
  font-weight: 700;
  font-family: inherit;
  display: inline-block;
  max-width: 100%;
}
.rectangle-shape {
  width: 4px;
  height: 131px;
  position: absolute;
  border-radius: 47px;
  background-color: #0217a3;
  transform: rotate(-90deg);
  margin-left:64px;
  margin-top:-14px;
}
.rectangle-shape1 {
  width: 4px;
  height: 103px;
  position: absolute;
  border-radius: 47px;
  background-color: #0217a3;
  transform: rotate(-90deg);
  margin-left:49px;
}
.frame-with-rectangle {
  height: 46px;
  flex: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 14px;
  min-width: 138px;
}
.frame-with-rectangle1 {
  height: 46px;
  flex: 2;
  display: flex;
  flex-direction: column;
  width: 108px;
  justify-content: flex-start;
  gap: 14px;
  
}
.dynamic-nature3 {
  margin: 0;
  position: relative;
  font-size: inherit;
  line-height: 141%;
  font-weight: 900;
  font-family: inherit;
  display: inline-block;
  height: 28px;
  flex-shrink: 0;
  cursor: pointer;
  font-family: "Open Sauce Sans";

}
.dynamic-nature4 {
  margin: 0;
  position: relative;
  font-size: inherit;
  line-height: 141%;
  font-weight: 900;
  font-family: inherit;
  display: inline-block;
  height: 28px;
  flex-shrink: 0;
  cursor: pointer;
  font-family: "Open Sauce Sans";
  width:109px;
}
.step-011 {
  margin: 0;
  position: relative;
  font-size: inherit;
  line-height: 141%;
  font-weight: 900;
  font-family: inherit;
  display: inline-block;
  height: 28px;
  flex-shrink: 0;
  opacity: 0.3;
  cursor: pointer;
  font-family: "Open Sauce Sans";
  width:111px;
}
.step-021 {
  margin: 0;
  position: relative;
  font-size: inherit;
  line-height: 141%;
  font-weight: 900;
  font-family: inherit;
  display: inline-block;
  height: 28px;
  flex-shrink: 0;
  opacity: 0.3;
  cursor: pointer;
  font-family: "Open Sauce Sans";
}
.scan-and-upload,.pro-tip{
  width: 336px;
  color: #000;
  font-family: Raleway;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.documents{
  width: 143px;
  height: 126px;
  color: #000;
  font-family: Raleway;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 122.222%; /* 26.889px */
}
.if-the-document{
  width: 401px;
  height: 205px;
  color: #000;
  font-family: Raleway;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 122.222%; /* 26.889px */
}
.care{
  color: #006FFF;
  font-family: Raleway;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 122.222%;
  text-decoration-line: underline;
}
.two-frames {
  /* align-self: stretch; */
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 1px 0px 0px;
  gap: 24px;
}
.your-spending-limit1 {
  margin: 0;
  width: 401px;
  height: 205px;
  position: relative;
  font-size: 22px;
  line-height: 122.22%;
  font-weight: 400;
  font-family: Raleway;
  color: #000;
  display: inline-block;
  flex-shrink: 0;
  max-width: 100%;
}
.user-assessment {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 65px;
  height: 368px;
  max-width: 100%;
}
.dynamic-nature2 {
  width: 480px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 52px 0px 0px;
  box-sizing: border-box;
  min-width: 480px;
  max-width: 100%;
}
.document-rectangle-group-section-2 {
  width: 100%; 
  height: 4px;
  position: relative;
  border-radius: 47px;
  background-color: rgba(217, 217, 217, 0.96); 
  margin-top: 20px;
  display: none;
}

.document-rectangle-section-2 {
  position:absolute;
  top: 0;
  left: 0;
  border-radius: 47px;
  background-color: rgba(217, 217, 217, 0.96);
  width: 100%;
  height: 100%;
  display: none; 
}

.document-step-step {
  position:relative;
  left: 0;
  border-radius: 47px; 
  background-color: #0217a3; 
  width: 50%;
  height: 4px;
  z-index: 1;
  transition: left 0.3s ease; 
}

.step-1 {
  left: 0; 
}

.step-2 {
  left: 50%;
}

@media (max-width: 450px) {
  .document-rectangle-group-section-2 {
    display: block; /* Show on mobile screens */
  }
  .rectangle-shape1{
    display: none;
  }
}
.parent-mask-group-child {
  align-self: stretch;
  width: 496px;
  position: relative;
  border-radius: 36px;
  background-color: rgba(217, 217, 217, 0.41);
  display: none;
  max-width: 100%;
}
.mask-group-icon5 {
  height: 530px;
  flex: 1;
  position: relative;
  max-width: 100%;
  overflow: hidden;
  object-fit: contain;
  z-index: 1;
}
.parent-mask-group {
  flex: 1;
  border-radius: 36px;
  background-color: rgba(217, 217, 217, 0.41);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 322px;
  max-width: 100%;
}
.three-step-frame {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 44px;
  max-width: 100%;
  text-align: left;
  font-size: 26px;
  color: #0217a3;
  font-family: "Open Sauce Sans";
}
.frame-with-masks {
  width: 1060px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  box-sizing: border-box;
  gap: 72px;
  min-height: 755px;
  max-width: 100%;
  text-align: center;
  font-size: 45px;
  color: #000;
  font-family: Raleway;
}
.we-do-it {
  margin: 0;
  align-self: stretch;
  position: relative;
  font-size: inherit;
  font-weight: 700;
  font-family: inherit;
}
.why-people-love {
  margin: 0;
  position: relative;
  font-size: 30px;
  font-weight: 400;
  font-family: inherit;
}
.why-love-koko {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 3px;
  max-width: 100%;
}
.three-frames {
  width: 530px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 28px 0px 20px;
  box-sizing: border-box;
  min-height: 104px;
  max-width: 100%;
}
.three-frames-group-child {
  height: 404px;
  width: 1280px;
  position: relative;
  background-color: #D0C0DD;
  display: none;
  max-width: 100%;
  z-index: 0;
}

.mask-group-icon6 {
  align-self: stretch;
  width: calc(100% / 2.5);
  position: relative;
  max-height: 100%;
  object-fit: contain;
  /* min-height: 280px; */
  max-width: 100%;
  z-index: 1;
  object-fit: contain;
  user-select: none;
}

.three-frames-group {
  flex: 1;
  background-color:#D0C0DD;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 57px 54px 58px;
  box-sizing: border-box;
  position: relative;
  gap: 39px;
  max-width: 100%;
  cursor: pointer;
  overflow-x: auto; /* Enable horizontal scrolling */
  overflow-y: hidden;
  white-space: nowrap;
  scroll-behavior: smooth;
}

.parent-mask-group-stack {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 0px 37px;
  box-sizing: border-box;
  max-width: 100%;
}

/* Hide scrollbar for Webkit browsers */
.three-frames-group::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for Firefox */
.three-frames-group {
  scrollbar-width: none; /* Firefox */
}
.mask-group-icon7 {
  align-self: stretch;
  width: 455px;
  position: relative;
  max-height: 100%;
  object-fit: contain;
  min-height: 289px;
  max-width: 100%;
  z-index: 1;
}
.mask-group-icon8 {
  width: 455px;
  position: absolute;
  margin: 0 !important;
  top: 57px;
  right: -217px;
  height: 289px;
  object-fit: contain;
  z-index: 1;
}
.only-the-best {
  margin: 0;
  position: relative;
  font-size: inherit;
  font-weight: 700;
  font-family: inherit;
}
.child-frame {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 9px 0px 0px;
  box-sizing: border-box;
  max-width: 100%;
}
.up-to-off-child {
  width: 172px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.up-to-off-item {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  height: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  z-index: 1;
}
.up-to-40 {
  position: relative;
  font-size: 7px;
  letter-spacing: -0.05em;
  font-family: "Open Sauce One";
  color: #fff;
  text-align: left;
}
.up-to-40-off-wrapper {
  cursor: pointer;
  border: none;
  padding: 8px 12px 8px 14px;
  background-color: #000;
  border-radius: 10.5px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  z-index: 2;
}
.up-to-40-off-wrapper:hover {
  background-color: #333;
}
.section-4-icon1 {
  height: 6px;
  width: 6px;
  position: relative;
  object-fit: cover;
  min-height: 6px;
}
.instore-online2 {
  position: relative;
  letter-spacing: -0.05em;
}
.frame-child7 {
  height: 142.7px;
  width: 142.7px;
  position: absolute;
  margin: 0 !important;
  top: -139.1px;
  right: -82.9px;
  object-fit: cover;
  z-index: 3;
}
.shopping-bag-parent {
  border-radius: 10.5px;
  background-color: #000;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 6px 9px 6px 10px;
  position: relative;
  gap: 2px;
  z-index: 2;
}
.up-to-off {
  width: 172px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 9px 11px 12px;
  box-sizing: border-box;
  position: relative;
  gap: 146px;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-24%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  color: #fff;
}
.rectangle-icon {
  width: 171px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.frame-child8 {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  height: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  z-index: 1;
}
.up-to-401 {
  position: relative;
  font-size: 7px;
  letter-spacing: -0.05em;
  font-family: "Open Sauce One";
  color: #fff;
  text-align: left;
}
.frame-child9 {
  height: 149.7px;
  width: 149.7px;
  position: absolute;
  margin: 0 !important;
  right: -77px;
  bottom: -146.1px;
  object-fit: contain;
  z-index: 3;
}
.up-to-40-off-parent {
  cursor: pointer;
  border: none;
  padding: 8px 12px 8px 15px;
  background-color: #000;
  border-radius: 10.5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  gap: 10px;
  white-space: nowrap;
  z-index: 2;
}
.up-to-40-off-parent:hover {
  background-color: #333;
}
.section-4-icon2 {
  height: 6px;
  width: 6px;
  position: relative;
  object-fit: cover;
  min-height: 6px;
}
.instore-online3 {
  position: relative;
  letter-spacing: -0.05em;
}
.shopping-bag-group {
  border-radius: 10.5px;
  background-color: #000;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 6px 9px 6px 10px;
  gap: 2px;
  white-space: nowrap;
  z-index: 2;
}
.parent-frame1 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 3px;
}
.rectangle-parent6 {
  width: 171px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 9px 11px 12px;
  box-sizing: border-box;
  position: relative;
  gap: 146px;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-20%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  color: #fff;
}
.first-group-frame-child {
  width: 172px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.second-group-rectangle {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  height: 100%;
  z-index: 1;
}
.up-to-402 {
  position: relative;
  font-size: 7px;
  letter-spacing: -0.05em;
  font-family: "Open Sauce One";
  color: #000;
  text-align: left;
}
.third-group-frame {
  cursor: pointer;
  border: none;
  padding: 8px 12px 8px 14px;
  background-color: #fff;
  border-radius: 10.5px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  z-index: 2;
}
.third-group-frame:hover {
  background-color: #e6e6e6;
}
.blinklogoweb-1-icon {
  height: 36px;
  width: 112px;
  position: relative;
  object-fit: cover;
  z-index: 2;
}
.web-logo-rectangle {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 17px 0px 19px;
}
.section-4-icon3 {
  height: 7px;
  width: 7px;
  position: relative;
  object-fit: cover;
  min-height: 7px;
}
.instore-online4 {
  position: relative;
  letter-spacing: -0.05em;
}
.stores-frame {
  border-radius: 10.5px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 5px 8px 6px 9px;
  gap: 2px;
  white-space: nowrap;
  z-index: 2;
}
.first-group-frame {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 9px 12px 14px;
  position: relative;
  gap: 55px;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-21%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}
.up-to-off-inner {
  width: 172px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.up-to-off-child1 {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  height: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  z-index: 1;
}
.section-4-icon4 {
  height: 7px;
  width: 7px;
  position: relative;
  object-fit: cover;
  min-height: 7px;
}
.instore-online5 {
  position: relative;
  letter-spacing: -0.05em;
}
.shopping-bag-container {
  border-radius: 10.5px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 5px 8px 6px 9px;
  gap: 2px;
  white-space: nowrap;
  z-index: 2;
}
.icon {
  width: 100%;
  height: 172px;
  position: absolute;
  margin: 0 !important;
  right: 0px;
  bottom: 16px;
  left: 0px;
  max-width: 100%;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: cover;
  z-index: 3;
}
.up-to-off1 {
  width: 172px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 180px 14px 12px;
  box-sizing: border-box;
  position: relative;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-33%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}
.up-to-off-child2 {
  width: 172px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.up-to-off-child3 {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  height: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  z-index: 1;
}
.frame-child10 {
  height: 24.1px;
  width: 120.9px;
  position: relative;
  object-fit: cover;
  z-index: 2;
}
.up-to-off-inner1 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 6px;
}
.section-4-icon5 {
  height: 7px;
  width: 7px;
  position: relative;
  object-fit: cover;
  min-height: 7px;
}
.instore-online6 {
  position: relative;
  letter-spacing: -0.05em;
}
.shopping-bag-parent1 {
  border-radius: 10.5px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 5px 8px 6px 9px;
  gap: 2px;
  white-space: nowrap;
  z-index: 2;
}
.up-to-off2 {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 93px 22px 12px 17px;
  position: relative;
  gap: 63px;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-35%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}
.instore-online-text-child {
  width: 172px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.fourth-group-frame {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  bottom: 0px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  height: 100%;
  z-index: 1;
}
.section-4-icon6 {
  height: 7px;
  width: 7px;
  position: relative;
  object-fit: cover;
  min-height: 7px;
}
.instore-online7 {
  position: relative;
  letter-spacing: -0.05em;
}
.last-group-frame {
  border-radius: 10.5px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 5px 8px 6px 9px;
  gap: 2px;
  white-space: nowrap;
  z-index: 2;
}
.rectangle-without-children {
  width: 100%;
  height: 173px;
  position: absolute;
  margin: 0 !important;
  right: 0px;
  bottom: 19px;
  left: 0px;
  max-width: 100%;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: cover;
  z-index: 3;
}
.instore-online-text {
  width: 173px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 180px 12px 14px;
  box-sizing: border-box;
  position: relative;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-37%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}
.up-to-off-child4 {
  width: 172px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.up-to-off-child5 {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  height: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  z-index: 1;
}
.section-4-icon7 {
  height: 6px;
  width: 6px;
  position: relative;
  object-fit: cover;
  min-height: 6px;
}
.instore-online8 {
  position: relative;
  letter-spacing: -0.05em;
}
.frame-child11 {
  height: 142.7px;
  width: 142.7px;
  position: absolute;
  margin: 0 !important;
  top: -139.4px;
  right: -82.9px;
  object-fit: cover;
  z-index: 3;
}
.shopping-bag-parent2 {
  border-radius: 10.5px;
  background-color: #000;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 5px 9px 6px 10px;
  position: relative;
  gap: 2px;
  z-index: 2;
}
.up-to-off3 {
  width: 172px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 180px 11px 13px;
  box-sizing: border-box;
  position: relative;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-24%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  color: #fff;
}
.up-to-off-child6 {
  width: 171px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.up-to-off-child7 {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  height: 100%;
  top: 0px;
  right: 1px;
  bottom: 1px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  z-index: 1;
}
.up-to-off-child8 {
  width: 149.7px;
  height: 149.7px;
  position: relative;
  object-fit: contain;
  z-index: 2;
}
.section-4-icon8 {
  height: 6px;
  width: 6px;
  position: relative;
  object-fit: cover;
  min-height: 6px;
}
.instore-online9 {
  position: relative;
  letter-spacing: -0.05em;
}
.shopping-bag-parent3 {
  border-radius: 10.5px;
  background-color: #000;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 5px 9px 6px 10px;
  gap: 2px;
  white-space: nowrap;
  z-index: 2;
}
.up-to-off4 {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 30px 10px 13px 12px;
  position: relative;
  gap: 1px;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-20%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  color: #fff;
}
.up-to-off-child9 {
  width: 172px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.up-to-off-child10 {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  height: 100%;
  z-index: 1;
}
.blinklogoweb-3-icon {
  height: 36px;
  width: 112px;
  position: relative;
  object-fit: cover;
  z-index: 2;
}
.blinklogoweb-3-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 17px 0px 19px;
}
.section-4-icon9 {
  height: 7px;
  width: 7px;
  position: relative;
  object-fit: cover;
  min-height: 7px;
}
.instore-online10 {
  position: relative;
  letter-spacing: -0.05em;
}
.shopping-bag-parent4 {
  border-radius: 10.5px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 5px 8px 5px 9px;
  gap: 2px;
  white-space: nowrap;
  z-index: 2;
}
.up-to-off5 {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 89px 12px 14px;
  position: relative;
  gap: 55px;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-21%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}
.up-to-off-child11 {
  width: 172px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.up-to-off-child12 {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  height: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  z-index: 1;
}
.section-4-icon10 {
  height: 7px;
  width: 7px;
  position: relative;
  object-fit: cover;
  min-height: 7px;
}
.instore-online11 {
  position: relative;
  letter-spacing: -0.05em;
}
.shopping-bag-parent5 {
  border-radius: 10.5px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 5px 8px 5px 9px;
  gap: 2px;
  white-space: nowrap;
  z-index: 2;
}
.icon1 {
  width: 100%;
  height: 172px;
  position: absolute;
  margin: 0 !important;
  right: 0px;
  bottom: 16px;
  left: 0px;
  max-width: 100%;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: cover;
  z-index: 3;
}
.up-to-off6 {
  width: 172px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 180px 14px 13px;
  box-sizing: border-box;
  position: relative;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-33%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}
.up-to-off-child13 {
  width: 172px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.up-to-off-child14 {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  height: 100%;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  z-index: 1;
}
.frame-child12 {
  height: 24.1px;
  width: 120.9px;
  position: relative;
  object-fit: cover;
  z-index: 2;
}
.up-to-off-inner2 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 6px;
}
.section-4-icon11 {
  height: 7px;
  width: 7px;
  position: relative;
  object-fit: cover;
  min-height: 7px;
}
.instore-online12 {
  position: relative;
  letter-spacing: -0.05em;
}
.shopping-bag-parent6 {
  border-radius: 10.5px;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 5px 8px 5px 9px;
  gap: 2px;
  white-space: nowrap;
  z-index: 2;
}
.up-to-off7 {
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 93px 22px 13px 17px;
  position: relative;
  gap: 63px;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-35%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}
.up-to-off-child15 {
  width: 172px;
  position: relative;
  border-radius: 20px;
  height: 210px;
  object-fit: cover;
  display: none;
  z-index: 0;
}
.up-to-off-child16 {
  width: 100%;
  position: absolute;
  margin: 0 !important;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border-radius: 20px;
  background: linear-gradient(0deg, #000 -87.22%, rgba(0, 0, 0, 0.00) 112.22%);
  height: 100%;
  z-index: 1;
}
.section-4-icon12 {
  height: 7px;
  width: 7px;
  position: relative;
  object-fit: cover;
  min-height: 7px;
}
.instore-online13 {
  position: relative;
  letter-spacing: -0.05em;
}
.icon2 {
  height: 173px;
  width: 173px;
  position: absolute;
  margin: 0 !important;
  top: -160px;
  right: -97px;
  object-fit: cover;
  z-index: 3;
}
.shopping-bag-parent7 {
  border-radius: 10.5px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 5px 8px 5px 9px;
  position: relative;
  gap: 2px;
  z-index: 2;
}
.up-to-off8 {
  width: 172px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding: 180px 12px 14px;
  box-sizing: border-box;
  position: relative;
  background-image: url("https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Educational-page/rectangle-37%402x.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
}
.rectangle1 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  gap: 18px;
  min-height: 444px;
  text-align: left;
  font-size: 5px;
  font-family: "Open Sauce One";
}
.parent-frame {
  width: 1166px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  box-sizing: border-box;
  gap: 50px;
  max-width: 100%;
  text-align: center;
  font-size: 45px;
  color: #000;
  font-family: Raleway;
}
.welcome-page {
  width: 100%;
  position: relative;
  background-color: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 0px 218px;
  box-sizing: border-box;
  gap: 62px;
  letter-spacing: normal;
  text-align: center;
  font-size: 45px;
  color: #000;
  font-family: Raleway;
}
.top-deals {
  margin: 0;
  flex: 1;
  position: relative;
  font-size: inherit;
  line-height: 117.86%;
  font-weight: 700;
  font-family: inherit;
  display: inline-block;
  max-width: 100%;
}
.top-deals-label {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 32px 0px 24px; /* replaced var(--padding-2xl) and var(--padding-xl) */
  box-sizing: border-box;
  max-width: 100%;
}
.fashion_body {
  background-color: white;
  border-radius: 16px;
}
.card-image{
  width:250px;
  height:308px;
}

.cards-wrapper3 {
  display: grid;
  grid-auto-flow: column;
  overflow: auto;
  white-space: nowrap;
  padding-right: 16px; /* replaced var(--page-margin) */
  gap: 1rem; /* add gap for spacing */
  padding-left:75px;
}

.cards-wrapper3-skeleton {
  display: grid;
  grid-auto-flow: column;
  overflow: auto;
  white-space: nowrap;
  padding-right: 16px; /* replaced var(--page-margin) */
  gap: 1rem; /* add gap for spacing */
}

.cards-wrapper3-skeleton .card4,
.cards-wrapper3 .card3,
.cards-wrapper3 .card5,
.cards-wrapper3 .top_cards,
.cards-wrapper3 .card4 {
  flex: 0 0 auto; /* Ensure cards don't shrink */
  display: grid;
  place-content: center;
  font-size: 1.5rem;
  height: 360px;
  width: 130px;
  margin-top: 5%;
  margin-bottom: 8%;
  margin-right: 128px;
}

.badge {
  position: absolute;
    left: -61px;
    top: 44px;
    text-transform: uppercase;
    font-size: 10.5px;
    font-weight: 500;
    background: #fafcfa;
    color: #000000;
    padding: 3px 10px;
    display: flex;
    width: 108px;
    height: 38px;
    padding: 6px 9px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    color: #000;
    font-family: "Open Sauce One";
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.35px;
}

.badge3 {
  position: absolute;
    left: -61px;
    bottom: 38px;
    font-size: 9px;
    font-weight: 500;
    background: #ffffff;
    color: #000000;
    padding: 1px 5px;
    margin-right: 15px;
    border-radius: 10.5px;
    display: flex;
    width: 94px;
    height: 26px;
    padding: 6px 9px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
    font-family: "Open Sauce One";
    font-size: 8px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.25px;
}

.top-deals-label-parent {
  width: 100%;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.deals-container{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mask-group-icon-mobile {
  display:none;
}
/* Only the best for you section card*/
.deals-container {
  background-color: white;
  border-radius: 16px;
}

.deal-card-image {
  width: 172px;
    height: 211px;
    margin-right: 18px;
}

.deals-cards-row {
  display: flex;
   /* overflow-x: auto;*/
    white-space: nowrap;
    /* padding-right: 16px; */
    gap: 1rem;
    padding-left: 17px;
}

.deals-cards-row-skeleton {
  display: flex; /* Use flexbox for horizontal scrolling */
  overflow-x: auto; /* Enable horizontal scrolling */
  white-space: nowrap; /* Ensure items don't wrap to the next line */
  padding-right: 16px; /* replaced var(--page-margin) */
  gap: 1rem; /* add gap for spacing */
}

.deals-cards-row-skeleton .deal-card-skeleton,
.deals-cards-row .deal-card,
.deals-cards-row .top-cards,
.deals-cards-row .deal-card-skeleton {
  flex: 0 0 auto;
    display: grid;
    place-content: center;
    font-size: 1.5rem;
    height: 211px;
    width: 172px;
    margin-top: 5%;
    /*margin-bottom: 8%;*/
}

.discount-badge {
  position: absolute;
    left: -3px;
    top: 8px;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
    background: #fafcfa;
    color: #000000;
    padding: 3px 10px;
    border-radius: 10.5px;
    color: #000;
    font-family: "Open Sauce One";
    font-size: 7px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.35px;
    display: flex;
    width: 72px;
    height: 25px;
    padding: 6px 9px;
    justify-content: center;
    align-items: center;
    gap: 10px;

}

.merchant-type-badge {
  position: absolute;
  left: -3px;
  bottom: 13px;
    font-size: 9px;
    font-weight: 500;
    background: #ffffff;
    color: #000000;
    padding: 1px 5px;
    margin-right: 15px;
    display: flex;
    width: 64px;
    height: 18px;
    padding: 6px 9px;
    justify-content: center;
    align-items: center;
    gap: 2px;
    flex-shrink: 0;
    border-radius: 10.5px;
    color: #000;
    font-family: "Open Sauce One";
    font-size: 5px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.25px;
}

.deals-section {
  width: 100%;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.deals-row {
  
}

@media (max-width: 768px) {
  .deals-cards-row {
    padding-left: 2px; 
    padding-right: 2px;
  }

  .deal-card-image {
    height: 146px;
    width: 120px;
  }
  
.deals-cards-row-skeleton .deal-card-skeleton,
.deals-cards-row .deal-card,
.deals-cards-row .top-cards,
.deals-cards-row .deal-card-skeleton {
  flex: 0 0 auto;
    display: grid;
    place-content: center;
    font-size: 1.5rem;
    height: 146px;
    width: 120px;
    margin-top: 5%;
    margin-bottom: 2%;
}
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #D9D9D9; 
  width:500px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(165, 165, 165, 0.56);; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
.deals-cards-row::-webkit-scrollbar-thumb {
  background: #0217A3;
}
@media screen and (max-width: 1200px) {
  .deals-cards-row{
    overflow-x:auto;
    padding-left: 16px;
  }
  .section-4-icon,.frame-parent3{
    overflow-x:auto;
    overflow-y: hidden;
  }
  .rectangle-parent1 {
    padding-top: 45px;
    padding-bottom: 57px;
    box-sizing: border-box;
  }

  .welcome-page-inner {
    padding-bottom: 36px;
    box-sizing: border-box;
  }

  .parent-frame {
    gap: 49px;
  }
  .deal-card{
    margin-bottom: 3%;
  }
  .mask-group-icon{
    top: 5%;
  }
}
@media screen and (max-width: 1050px) {
  .up-to-off-frame{
        justify-content: center;
    }
  .mainlogo-hd-h-2101-1-icon{
    height: 84px;
    width: 186px;
    position: absolute;
    right: 55px;
  }
  .your-spending-limit {
    width: 420px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0px;
    max-width: 100%;
    text-align: center;
    font-size: 13px;
    color: #021fa3;
  }
  .frame-item {
    width: 110px;
    height: 110px;
}
  .interest-free {
    font-size: 46px;
    line-height: 70px;
  }

  .splurge-in-three {
    font-size: 62px;
    line-height: 94px;
  }

  .getting-started-with {
    font-size: 24px;
  }

  .how-to-register-your {
    font-size: 36px;
  }

  .how-to-make {
    font-size: 36px;
    text-align:center;
    width:80%;
  }

  .instore-payments {
    font-size: 30px;
  }


  .online-payments {
    font-size: 30px;
   
  }

 
  .frame-parent4 {
    flex-wrap: wrap;
  }

  .ready-to-boost {
    font-size: 36px;
  }

  .dynamic-nature2 {
    flex: 1;
  }

  .three-step-frame {
    flex-wrap: wrap;
  }

  .frame-with-masks {
    gap: 36px;
  }

  .we-do-it {
    font-size: 36px;
  }

  .why-people-love {
    font-size: 24px;
  }

  .three-frames-group {
    /* flex-wrap: wrap;
    padding-left: 27px;
    padding-right: 27px;
    box-sizing: border-box; */
  }

  .only-the-best {
    font-size: 36px;
  }
  .mask-group-icon6 {
    align-self: stretch;
    /* width: calc(100% / 2); */
}
.rectangle-container-reg{
        order: -1;
    }
  .parent-mask-group {
        order: -1;
    }
  .up-to-off-frame-inner{
    order: 1;
}
}
@media screen and (max-width: 850px) {
  .parent-mask-group{
    order:-1;
  }
  .rectangle-container-reg {
    order: -1;
    }
.mask-group-icon6 {
    align-self: stretch;
    width: calc(100% / 2);
}
.frame-item {
        width: 95px;
        height: 95px;
    }
  .your-spending-limit {
      width: 330px;
    }
  .splurge-in-three {
    font-size: 63px;
    top: 8px;
    line-height: 67px;
    width: 300px;
}
.interest-free {
    font-size: 27px;
    line-height: 62px;
}
.mask-group-icon-mobile{
  height: 481px;
  width: 398px;
  bottom: 0px;
  right: 13px;
  position: absolute;
  display: block;

}
.mask-group-icon{
  display: none;
}
.up-to-off-frame{
  justify-content: center;
}
}

@media screen and (max-width: 750px) {
  
  .mask-group-icon5 {
    height: 366px;
  }
  .dynamic-nature2 {
        order: 2;
    }
  .your-spending-limit {
    flex-wrap: wrap;
  }

  .weather-icon {
    padding-top: 51px;
    box-sizing: border-box;
    min-width: 100%;
  }

  .rectangle-parent {
    gap: 85px;
    padding-left: 26px;
    padding-top: 20px;
    padding-bottom: 54px;
    box-sizing: border-box;
  }

  .up-to-off-frame {
    gap: 18px;
  }

  .dynamic-nature {
    gap: 24px;
    margin-top: 20px;
  }

  .rectangle {
    gap: 15px;
  }

  .rectangle-parent1 {
    gap: 33px;
    padding: 29px 27px 37px;
    box-sizing: border-box;
  }

  .welcome-page-inner {
    padding-bottom: 23px;
    box-sizing: border-box;
  }

  .user-assessment {
    gap: 32px;
  }

  .dynamic-nature2 {
    min-width: 100%;
  }

  .three-step-frame {
    gap: 22px;
  }

  .frame-with-masks {
    gap: 18px;
  }
  .mask-group-icon6 {
   
    min-height: 149px;
    max-width: 100%;
    
}
  .three-frames-group {
    /* gap: 19px; */
  }
 .mask-group-icon6{
  width:calc(100% / 1.5)
 }
  .parent-frame {
    gap: 25px;
  }

  .welcome-page {
    gap: 31px;
  }
  .rectangle-container-reg {
    min-width: 251px;
    height: 414px;
    width:100%
    
}
.frame-group {
    gap: 4px;
}
  .rectangle-parent {
    width: 100%;
    margin: 0 !important;
    top: 0px;
    right: 0px;
    left: 0px;
    border-radius: 0px 0px 110px 0px;
    background-color: #d0c0dd;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 7px 0px 0px 22px;
    box-sizing: border-box;
    max-width: 100%;
  }
  .frame-item {
    height: 50px;
    width: 50px;
    position: relative;
    object-fit: cover;
    min-height: 50px;
    z-index: 2;
  }
  .your-spending-limit{
   
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 4px;
    font-size: 8px;
    width: 50%;
  
  }
  .mask-group-icon{
    display: none;
  }
  .weather-icon {
    padding-top: 22px;
  }
  .mask-group-icon-mobile {
    position: absolute;
        top: -16px;
        right: -30px;
        width: 248px;
        height: 391px;
        -o-object-fit: cover;
        object-fit: cover;
        z-index: 1;
        display: block;
  }
  .instant-approval-for{
    display:none;
  }
  .instant-approval-for-mobile{
    display:block;
    width: 60px;
  }
  .frame-item{
    width:75px;
    height:75px;
  }
  .interest-free {
    font-size: 21px;
    line-height: 53px;
    top: -3px;
  }

  .splurge-in-three {
    line-height: 110%;
    font-weight: 900;
    z-index: 2;
    font-family: "Open Sauce One";
    font-size: 50px;
    font-style: normal;
    width: 200px;
  }
  .mainlogo-hd-h-2101-1-icon{
    position: absolute;
        top: 0px;
        right: 56px;
        width: 98px;
        height: 50px;
        object-fit: cover;
        z-index: 2;
  }
  .frame-parent {
    gap: 20px;
  }

  .rectangle-parent {
    gap: 43px;
    height: 375px;
  }
  .mask-group-icon1{
    height: 410px;}

    .cards-wrapper3{
    margin-bottom: 10%;
    padding-right: 0px;
    padding-left: 30px;
}
.card-image {
    width: 200px;
    height: 258px;
}
.cards-wrapper3-skeleton .card4,
.cards-wrapper3 .card3,
.cards-wrapper3 .card5,
.cards-wrapper3 .top_cards,
.cards-wrapper3 .card4 
{
    flex: 0 0 auto;
    display: grid;
    place-content: center;
    font-size: 1.5rem;
    height: 305px;
    width: 180px;
    margin-bottom: 8%;
    margin-right: 28px;
}

.badge{
    position: absolute;
    left: -10px;
    top: 38px;
    text-transform: uppercase;
    font-weight: 500;
    background: #fafcfa;
    color: #000000;
    padding: 3px 10px;
    display: flex;
    width: 85px;
    height: 28px;
    padding: 6px 9px;
    justify-content: center;
    font-size:8px;
  }
.badge3 {
    left: -10px;
    bottom: 38px;
    display: flex;
    width: 80px;
    height: 21px;
    padding: 6px 9px;
    justify-content: center;
    align-items: center;
    font-size:6px;   
}
.top-deals {
    margin-top: 25px;
    
}
.welcome-page {
    padding: 0px 0px 89px;
}
}
@media screen and (max-width: 652px) {
  .rectangle-parent1 {
    background-color: white;
  }
  .ready-to-boost {
        margin-bottom: 20px;
    }
}
@media screen and (max-width: 522px) {
  .up-to-off-frame-inner{
    width: 382px;
  }

  .your-spending-limit {
        width: 60%;
    }

  .up-to-off-frame-child{
    width: 7px;
  }
}
@media screen and (max-width: 465px) {
  .up-to-off-frame-inner{
    width: 362px;
  }
  .up-to-off-frame-child{
    width: 4px;
  }
}


@media screen and (max-width: 431px) {
    .mask-group-icon1 {
        height: 338px;
    }
}

@media screen and (max-width: 450px) {
  .frame-with-rectangle {
    min-width: 160px;
  }
  .welcome-page {
    padding: 0px 0px 30px;
}
  .discount-badge{
    width: 50px;
    height: 18px;
    top:6px;
    left: -8px;
  }
  merchant-type-badge{
    width: 44px;
    height: 13px;
    bottom:8px;
    left:-8px;
  }
  .badge{
    position: absolute;
    left: -10px;
    top: 38px;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: 500;
    background: #fafcfa;
    color: #000000;
    padding: 3px 10px;
    display: flex;
    width: 65px;
    height: 23px;
    padding: 6px 9px;
    justify-content: center;
    font-size:7px;
  }
  .badge3 {
    left: -10px;
    bottom: 38px;
    display: flex;
    width: 58px;
    height: 16px;
    padding: 6px 9px;
    justify-content: center;
    align-items: center;
    font-size:5px;
    
}
  .step-011,.step-021{
    font-size:16px;
  }
  .dynamic-nature4{
    font-size: 16px;
}
  .scan-and-upload, .pro-tip {
    font-size: 18px;
}
.documents{
    font-size: 14px;
    
}
  .mask-group-icon1 {
        height: 340px;
    }
.rectangle-group-section-2 {
    height: 325px;
    top:12px;
}
.step-step{
  height:65px;
}
.step-step-2{
  top:65px;
}
.step-step-3{
  top:130px;
}
.step-step-4{
  top:195px;
}
.step-step-5{
  top:260px;
}
  .step-01-parent, .step-02-parent, .step-03-parent, 
  .step-04-parent, .step-05-parent {
    gap: 3px;
    height: 56px;
}
  .up-to-off-frame-inner {
    width: 310px;
  }
  .up-to-off-frame-child{
    width: 0cqi;
  }
  .cards-wrapper3{
    margin-bottom:10%;
    padding-right: 0px;
    padding-left: 30px;
}
  .card-image {
    width: 155px;
height: 191px;
}
.cards-wrapper3-skeleton .card4,
.cards-wrapper3 .card3,
.cards-wrapper3 .card5,
.cards-wrapper3 .top_cards,
.cards-wrapper3 .card4 
{
     flex: 0 0 auto;
    display: grid;
    place-content: center;
    font-size: 1.5rem;
    height: 255px;
    width: 130px;
    /* margin-top: 5%; */
    margin-bottom: 8%;
    margin-right: 28px;
}
  .rectangle-container-reg {
    min-width: 258px;
    height: 342px;
}
.frame-group {
    gap: 4px;
}
  .rectangle-parent {
    width: 100%;
    margin: 0 !important;
    top: 0px;
    right: 0px;
    left: 0px;
    border-radius: 0px 0px 110px 0px;
    background-color: #d0c0dd;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 7px 0px 0px 22px;
    box-sizing: border-box;
    max-width: 100%;
  }
  .frame-item {
    height: 50px;
    width: 50px;
    position: relative;
    object-fit: cover;
    min-height: 50px;
    z-index: 2;
  }
  .your-spending-limit{
   
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 4px;
    font-size: 8px;
    width: 219px;
  
  }
  .mask-group-icon{
    display: none;
  }
  .weather-icon {
    padding-top: 22px;
  }
  .mask-group-icon-mobile {
    position: absolute;
        top: -16px;
        right: -46px;
        width: 248px;
        height: 331.4px;
        -o-object-fit: cover;
        object-fit: cover;
        z-index: 1;
        display: block;
  }
  .instant-approval-for{
    display:none;
  }
  .instant-approval-for-mobile{
    display:block;
    width: 60px;
  }
  .frame-item{
    width:60px;
    height:60px;
  }
  .interest-free {
    font-size: 17px;
        line-height: 53px;
        top: -3px;
  }

  .splurge-in-three {
    line-height: 110%;
        font-weight: 900;
        z-index: 2;
        font-family: "Open Sauce One";
        font-size: 45px;
        font-style: normal;
        width: 200px;
  }
  .mainlogo-hd-h-2101-1-icon{
    position: absolute;
        top: 0px;
        right: 17px;
        width: 98px;
        height: 50px;
        object-fit: cover;
        z-index: 2;
  }
  .frame-parent {
    gap: 20px;
  }

  .rectangle-parent {
    gap: 43px;
    height: 316px;
  }

  .getting-started-with {
    font-size: 18px;
  }

  .how-to-register-your {
    font-size: 27px;
    height: 70px;
  }

  .step-01 {
    font-size: 21px;
    line-height: 29px;
  }

  .open-the-koko {
    font-size: 18px;
    line-height: 25px;
  }

  .step-02 {
    font-size: 21px;
    line-height: 29px;
  }

  .tap-on-my {
    font-size: 18px;
    line-height: 25px;
  }

  .step-03 {
    font-size: 21px;
    line-height: 29px;
  }
  
  .navigate-to-payment {
    font-size: 18px;
    line-height: 25px;
  }

  .step-04 {
    font-size: 21px;
    line-height: 29px;
  }

  .click-on-add {
    font-size: 18px;
    line-height: 25px;
  }

  .step-05 {
    font-size: 21px;
    line-height: 29px;
  }

  .verify-your-card {
    font-size: 18px;
    line-height: 25px;
  }

  .how-to-make {
    font-size: 27px;
    text-align:center;
  }

  .instore-payments {
    font-size: 23px;
    margin-top:20px;
  }

  .click {
    font-size: 18px;
    line-height: 22px;
    flex: 1;
  }

  .scan {
    font-size: 18px;
    line-height: 22px;
  }

  .scan-wrapper {
    flex: 1;
  }

  .pay {
    font-size: 18px;
    line-height: 22px;
  }

  .click-parent {
    flex-wrap: wrap;
  }

  .online-payments {
    font-size: 23px;
    margin-top:47px;
  }

  .choose-koko-at {
    font-size: 18px;
  }

  .log-in-with {
    font-size: 18px;
  }

  .make-your-first-container {
    font-size: 18px;
  }

  .rectangle-parent1 {
    gap: 16px;
    border-radius: 110px 0px 0px 0px;
    background-color:white;
  }

  .ready-to-boost {
    font-size: 27px;
    margin-top: 30px;
    margin-bottom: -30px;
  }

  .dynamic-nature3 {
    font-size: 21px;
    line-height: 29px;
  }

  .step-011 {
   
    line-height: 29px;
  }

  .step-021 {
    
    line-height: 29px;
  }

  .two-frames {
    flex-wrap: wrap;
    margin-bottom: -15px;
  }
  .top-deals {
    margin-top: 45px;
    font-size: 27px;
    
}
  .your-spending-limit1 {
    font-size: 14px;
    line-height: 22px;
    width: 370px;
  }

  .dynamic-nature2 {
    padding-top: 0px;
    box-sizing: border-box;
  }

  .we-do-it {
    font-size: 27px;
  }

  .why-people-love {
    font-size: 18px;
  }

  .three-frames-group {
    padding-top: 37px;
    padding-bottom: 38px;
    /* box-sizing: border-box; */
  }
  .mask-group-icon6{
    width:calc(100% );
  }
  .only-the-best {
    font-size: 27px;
    margin-bottom:-10px;
  }

  .welcome-page {
    gap: 15px;
  }
  .user-assessment {
    gap: 25px;
    height:270px;
    margin-bottom: 15px;
  }
  .three-frames{
    min-height: 75px;
}
}

@media screen and (max-width: 430px) {
  .interest-free {
    font-size: 17px;
        line-height: 53px;
        top: -3px;
  }

  .splurge-in-three {
    font-size: 39px;
    line-height: 39px;
    width:180px;
  }
  .mainlogo-hd-h-2101-1-icon {
    position: absolute;
    top: 0px;
    right: 16px;
    width: 82px;
    height: 41px;
    object-fit: cover;
    z-index: 2;
  }
  .interest-free-parent {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 100%;
  
  color: #fff;
}
  .frame-parent {
    gap: 20px;
  }

  .rectangle-parent {
    gap: 43px;
  }

  .getting-started-with {
    font-size: 18px;
  }

  .how-to-register-your {
    font-size: 27px;
  }

  .step-01 {
    font-size: 21px;
    line-height: 29px;
  }

  .open-the-koko {
    font-size: 18px;
    line-height: 25px;
  }

  .step-02 {
    font-size: 21px;
    line-height: 29px;
  }

  .tap-on-my {
    font-size: 18px;
    line-height: 25px;
  }

  .step-03 {
    font-size: 21px;
    line-height: 29px;
  }

  .navigate-to-payment {
    font-size: 18px;
    line-height: 25px;
  }

  .step-04 {
    font-size: 21px;
    line-height: 29px;
  }

  .click-on-add {
    font-size: 18px;
    line-height: 25px;
  }

  .step-05 {
    font-size: 21px;
    line-height: 29px;
  }

  .verify-your-card {
    font-size: 18px;
    line-height: 25px;
  }

  .how-to-make {
    font-size: 27px;
  }

  .instore-payments {
    font-size: 23px;
  }

  .click {
    font-size: 18px;
    line-height: 22px;
    flex: 1;
  }

  .scan {
    font-size: 18px;
    line-height: 22px;
  }

  .scan-wrapper {
    flex: 1;
  }

  .pay {
    font-size: 18px;
    line-height: 22px;
  }

  .click-parent {
    flex-wrap: wrap;
  }

  .online-payments {
    font-size: 23px;
  }

  .choose-koko-at {
    font-size: 18px;
  }

  .log-in-with {
    font-size: 18px;
  }

  .make-your-first-container {
    font-size: 18px;
  }

  .rectangle-parent1 {
    gap: 16px;
  }

  .ready-to-boost {
    font-size: 27px;
  }

  .dynamic-nature3 {
    font-size: 21px;
    line-height: 29px;
  }

  .step-011 {
    
    line-height: 29px;
  }

  .step-021 {
    
    line-height: 29px;
  }

  .two-frames {
    flex-wrap: wrap;
  }

  .your-spending-limit1 {
    line-height: 22px;
  }

  .dynamic-nature2 {
    padding-top: 0px;
    box-sizing: border-box;
  }

  .we-do-it {
    font-size: 27px;
  }

  .why-people-love {
    font-size: 18px;
  }

  .three-frames-group {
    padding-top: 37px;
    padding-bottom: 38px;
    /* box-sizing: border-box; */
  }
  .mask-group-icon6{
    width:calc(100% );
  }
  .only-the-best {
    font-size: 27px;
  }

  .welcome-page {
    gap: 15px;
  }
}

@media screen and (max-width: 399px) {
  .ready-to-boost {
      margin-bottom: 0px;
    }
}

@media screen and (max-width: 389px) {
  .up-to-off-frame-inner{
    width: 272px;
  }
  .your-spending-limit {
    width: 178px;
  }
  .frame-item {
        width: 50px;
        height: 50px;
    }
    .rectangle-parent{
        height: 295px;
    }
    .mask-group-icon-mobile {
        width: 228px;
        height: 311.4px;
    }
    .iphone-12-15-pro-1 {
      height: 354px;
      width: 315px;
    }
    .iphone-12-15-pro-5{
      height: 354px;
      width: 315px;
    }
}
@media screen and (max-width: 350px) {
    .frame-with-rectangle {
    min-width: 100px;
}
.up-to-off-frame-inner {
        width: 200px;
    }
    .iphone-12-15-pro-1{
        height: 294px;
        width: 255px;
    }
    .iphone-12-15-pro-5 {
        height: 294px;
        width: 255px;
}
}
@media screen and (max-width: 300px) {
  .step-011 {
    width: 91px;
}
.dynamic-nature4{
    width: 89px;
}
.ready-to-boost {
        margin-bottom: 22px;
    }
}

</style>
  